import { Button, Grid, Popover } from "@material-ui/core";
import {
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
} from "@mui/material";
import { CaretDown, Stack, User } from "phosphor-react";
import PropTypes from "prop-types";
import { useState } from "react";
import * as Icon from "react-feather";
import {
  FilterButton,
  SortButton,
} from "../../CommonComponents/CommonButtons/CommonButtons.Component";
import ProjectPageFiltersModal from "../ProjectPageModals/ProjectPageFiltersModal";
import useStyles from "./ProjectPageTools.styles";

function ProjectTools({
  toggleCardView,
  openNewProjModal,
  isCardView,
  handleFilter,
  value,
  updateRefreshToken,
  onSubmit,
  defaultvalue,
  handleProjectView,
  projectView,
  handleOpenCreateTeamModal,
  myTeams,
  setSelectedTeam,
  selectedTeam,
  projectCount,
}) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [btnActive, setBtnActive] = useState(false);
  const [selectedDropdownOption, setSelectedDropdownOption] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const handlePopoverOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <Grid container className={classes.root} justify="space-between">
      <Grid item lg={4} md={4} sm={2} xs={12}>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <div className={classes.title}>
            Projects{" "}
            <span style={{ marginLeft: "14px", color: "#6C65D9" }}>
              {projectCount ?? 0}
            </span>
          </div>
          <div>
            <Box sx={{ width: 260 }}>
              <Button onClick={handlePopoverOpen} sx={{ width: "100%", p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "white",
                    backgroundColor: "#252A38",
                    p: "6px 12px",
                    borderRadius: "10px",
                    width: "100%",
                    justifyContent: "space-between",
                    border: "2px solid #606479",
                  }}
                >
                  {selectedTeam === "my-projects" ? (
                    <>
                      <User size={20} color="#fff" />
                      <Typography>My Projects</Typography>
                      <CaretDown color="#fff" size={20} />
                    </>
                  ) : selectedTeam?.id ? (
                    <>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="20" height="20" rx="2" fill="#659BD9" />
                      </svg>

                      {/* Truncate team name */}
                      <Typography
                        noWrap
                        sx={{
                          maxWidth: 140,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {selectedTeam?.name}
                      </Typography>

                      <CaretDown color="#fff" size={20} />
                    </>
                  ) : (
                    <>
                      <Stack size={20} color="#fff" />
                      <Typography>All Projects</Typography>
                      <CaretDown color="#fff" size={20} />
                    </>
                  )}
                </Box>
              </Button>

              {/* Popover */}
              <Popover
                open={Boolean(menuAnchorEl)}
                anchorEl={menuAnchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                PaperProps={{
                  sx: {
                    backgroundColor: "#252A38",
                    borderRadius: "12px",
                    border: "1px solid #3E4759",
                    boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.25)",
                    minWidth: 260,
                    mt: "8px",
                  },
                }}
              >
                <MenuList
                  sx={{
                    p: "8px",
                    backgroundColor: "#252A38",
                    border: "1px solid #606479",
                    borderRadius: "10px",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setSelectedDropdownOption("my-projects");
                      setSelectedTeam("my-projects");
                      handlePopoverClose();
                    }}
                    className={classes.menuItem}
                  >
                    <ListItemIcon className={classes.listIcon}>
                      <User size={20} color="#fff" />
                    </ListItemIcon>
                    <ListItemText
                      primary="My Project"
                      className={classes.listText}
                    />
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setSelectedDropdownOption("all-projects");
                      setSelectedTeam(null);
                      handlePopoverClose();
                    }}
                    className={classes.menuItem}
                  >
                    <ListItemIcon className={classes.listIcon}>
                      <Stack size={20} color="#fff" />
                    </ListItemIcon>
                    <ListItemText
                      primary="All Projects"
                      className={classes.listText}
                    />
                  </MenuItem>

                  {myTeams?.map((sin) => (
                    <MenuItem
                      key={sin.id}
                      onClick={() => {
                        setSelectedDropdownOption("team-projects");
                        setSelectedTeam(sin);
                        handlePopoverClose();
                      }}
                      className={classes.menuItem}
                    >
                      <ListItemIcon className={classes.listIcon}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="20" height="20" rx="2" fill="#659BD9" />
                        </svg>
                      </ListItemIcon>

                      <ListItemText
                        primary={sin?.name}
                        primaryTypographyProps={{
                          noWrap: true,
                          sx: { maxWidth: 150 },
                        }}
                      />
                    </MenuItem>
                  ))}
                </MenuList>
              </Popover>
            </Box>
          </div>

          {/* <Tabs
            value={projectView}
            onChange={(event, value) => {
              handleProjectView(value);
            }}
          >
            <Tab
              value={"active"}
              className={classes.tab}
              label={
                <div className={classes.tabItems}>
                  {projectView === "active" ? (
                    <>
                      <ProjectIconWhite />
                      <span className={classes.active}>Active</span>
                    </>
                  ) : (
                    <>
                      <ProjectIcon />
                      <span className={classes.inActive}>Active</span>
                    </>
                  )}
                </div>
              }
            />
            <Tab
              value={"archived"}
              className={classes.tab}
              label={
                <div className={classes.tabItems}>
                  {projectView === "archived" ? (
                    <>
                      <ArchiveBox size={20} className={classes.active} />
                      <span className={classes.active}>Archived</span>
                    </>
                  ) : (
                    <>
                      <ArchiveBox size={20} className={classes.inActive} />
                      <span className={classes.inActive}>Archived</span>
                    </>
                  )}
                </div>
              }
            />
          </Tabs> */}
        </div>
      </Grid>
      <Grid
        container
        item
        lg={8}
        md={8}
        sm={10}
        xs={12}
        className={classes.projectPageToolsGrid}
        justify="flex-end"
      >
        {/* <Grid item className={classes.centerItem}>
          <Button
            className={classes.projectPageButton}
            onClick={toggleCardView}
          >
            {isCardView ? (
              <>
                {" "}
                <ListBullets size={27} />{" "}
                <p className={classes.tool}>List View</p>
              </>
            ) : (
              <>
                <ListBullets size={27} />{" "}
                <p className={classes.tool}>Card View</p>{" "}
              </>
            )}
          </Button>
        </Grid> */}
        <Grid item className={classes.centerItem}>
          <FilterButton btnActive={btnActive} openFilterModal={handleClick} />
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            PaperProps={{
              style: {
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
              },
            }}
          >
            <div className={classes.popoverArrowTriangle}></div>
            <div style={{ position: "relative" }}>
              <div className={classes.popoverArrow}></div>
              <ProjectPageFiltersModal
                handleFilter={handleFilter}
                value={value}
                updateRefreshToken={updateRefreshToken}
                closeFilterModal={handleClose}
                setBtnActive={setBtnActive}
              />
            </div>
          </Popover>
        </Grid>
        <Grid item className={classes.centerItem}>
          <SortButton
            onSubmit={onSubmit}
            defaultvalue={defaultvalue}
            type="project"
          />
        </Grid>
        <Grid item>
          <Button
            size="small"
            id="NewProject"
            className={classes.projectPageNewProjButton}
            disableElevation
            onClick={openNewProjModal}
          >
            <Icon.Plus className={classes.plusIcon} />
            <span style={{ fontSize: "16px" }}>New Project</span>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ProjectTools;

ProjectTools.propTypes = {
  toggleCardView: PropTypes.func,
  openFilterModal: PropTypes.func,
  openSortModal: PropTypes.func,
  openNewProjModal: PropTypes.func,
  isCardView: PropTypes.bool,
};
